const VILLA_CATEGORY = 'villa';

/**
 * @param {string} categoryName merchant_category_name of the merchant
 * @returns {string} i18n key for the "Book Our …" heading
 */
export function getBookOurTitleKey(categoryName) {
  const isVilla = (categoryName || '').trim().toLowerCase() === VILLA_CATEGORY;
  return isVilla
    ? 'hotel.concierge.fitur.book-our-villas'
    : 'hotel.concierge.fitur.book-our-rooms';
}



// WEBPACK FOOTER //
// ./src/utils/merchantCategory.js